module.exports = __webpack_public_path__ + "static/media/S4N7-4.32dc7ca3.svg";